module.exports = __webpack_public_path__ + "static/media/kswan.891b596d.jpg";